import { Typography } from '@material-ui/core';
import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Alert } from '@material-ui/lab';
import Button from '@material-ui/core/Button';
import { ScrollToTopOnMount } from '../../components/scroll-to-top-on-mount/scroll-to-top-on-mount';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '400px',
    maxWidth: '600px',
    margin: '0 auto',
  },
  button: {
    marginTop: theme.spacing(2),
  },
}));

export function ThankYouPage() {
  return (
    <ThankYouPageWrapper>
      <ThankYouPageTitle>Tack för din beställning</ThankYouPageTitle>
      <ThankYouPageDescription>
        Ditt ärende har börjat handläggas och vi återkommer inom kort med mer
        information via e-post eller telefon.
      </ThankYouPageDescription>

      <ThankYouPageHomeLink />
    </ThankYouPageWrapper>
  );
}

export function ThankYouPageWrapper(props: { children: React.ReactNode }) {
  const classes = useStyles();

  return (
    <React.Fragment>
      <ScrollToTopOnMount />

      <Alert severity="success" className={classes.root}>
        {props.children}
      </Alert>
    </React.Fragment>
  );
}

export function ThankYouPageTitle(props: { children: React.ReactNode }) {
  return <Typography variant="h5">{props.children}</Typography>;
}

export function ThankYouPageDescription(props: { children: React.ReactNode }) {
  return <Typography variant="body1">{props.children}</Typography>;
}

export function ThankYouPageHomeLink() {
  const classes = useStyles();

  return (
    <Button
      className={classes.button}
      href={process.env.REACT_APP_GATSBY_SITE_LINK}
      color="inherit"
      variant="outlined"
    >
      Tillbaka till startsidan
    </Button>
  );
}
